export default {"src":"/_next/static/media/existing-issues.e9129b2d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};